import { createSlice } from '@reduxjs/toolkit'

const getInitialState = () => ({
  card: null as any,
  cashBackEarned: 0,
  enrolledInCashBack: false,
  retentionOfferEligible: false,
  retentionOfferCampaignId: false as string | false,
  bankAccountLinked: false,
  isPrimary: true,
  hasMultipleSecondaryCards: false,
  selectedReason: null as string | null,
  otherReasonText: '',
  hasTriedToCancel: false,
  processingRequest: false,
  cancelResult: null as any,
  retentionEnrollResult: null as any,
})

const bdmcCancelCardSlice = createSlice({
  name: 'bdmcCancelCard',
  initialState: getInitialState(),
  reducers: {
    initBdmcCancelCard(state, action) {
      const {
        card,
        cashBackEarned = 0,
        enrolledInCashBack = false,
        retentionOfferEligible = false,
        retentionOfferCampaignId = false,
        bankAccountLinked = false,
        isPrimary = true,
        hasMultipleSecondaryCards = false,
      } = action.payload || {}

      state.card = card
      state.cashBackEarned = cashBackEarned
      state.enrolledInCashBack = enrolledInCashBack
      state.retentionOfferEligible = retentionOfferEligible
      state.retentionOfferCampaignId = retentionOfferCampaignId
      state.bankAccountLinked = bankAccountLinked
      state.isPrimary = isPrimary
      state.hasMultipleSecondaryCards = hasMultipleSecondaryCards
    },
    updateSelectedCancelReason(state, action) {
      state.selectedReason = action.payload
    },
    updateOtherReasonText(state, action) {
      state.otherReasonText = action.payload
    },
    setHasTriedToCancel(state, action) {
      state.hasTriedToCancel = action.payload
    },
    setProcessingRequest(state, action) {
      state.processingRequest = action.payload
    },
    setCancelResult(state, action) {
      state.cancelResult = action.payload
    },
    setRetentionEnrollResult(state, action) {
      state.retentionEnrollResult = action.payload
    },
    resetBdmcCancelCard() {
      return getInitialState()
    },
  },
})

export const {
  initBdmcCancelCard,
  updateSelectedCancelReason,
  updateOtherReasonText,
  setHasTriedToCancel,
  setProcessingRequest,
  setCancelResult,
  setRetentionEnrollResult,
  resetBdmcCancelCard,
} = bdmcCancelCardSlice.actions

export default bdmcCancelCardSlice.reducer
